import "./Services.css";

export default function Services() {
  return (
    <div className="services-container">
      <h2>Our Services</h2>
      <div className="services-list">
        <div className="service-card">
          <h3>Clearing and Forwarding</h3>
          <p>With Luztow, for over (17) years of ocean experience, you can expect swift processing, transparent communication, and cost-effective solutions.
          We provide end-to-end support, ensuring your cargo clears customs seamlessly, minimizing delays and maximizing your productivity.</p>
          <p>You can trust us to handle all your Customs clearing and forwarding ranging from documentation to cargo clearance needs with your interest at heart with precision. We will take care of every step of the process, from pickup to final delivery..</p>
           <img 
          src="/assets/Msc Gulsun.jpg"
          alt="Msc Gulsun.jpg"
          />
        </div>
          <div className="service-card">
          <h3>Air Freighting</h3>
          <p>We can help air freight your cargo to various countries you can expect swift processing, transparent communication, and cost-effective solutions. We provide end-to-end support, ensuring your cargo clears customs seamlessly, minimizing delays in all the cargo airports accross the country and maximizing your productivity.</p>
          <p>We provide end-to-end support, ensuring your cargo clears customs seamlessly, minimizing delays and maximizing your productivity.</p>
          <p>You can trust us to handle all your Customs clearing and forwarding ranging from documentation to cargo clearance needs with your interest at heart with precision. We will take care of every step of the process, from pickup to final delivery..</p>
           <img 
          src="/assets/aircargo.jpg"
          alt="aircargo.jpg"
          />
        </div>
        <div className="service-card">
          <h3>Ship Chartering</h3>
          <p>Our Ship Chattering service gives you access to a vast network of reputable vessel owners and operators worldwide.</p>
          <p>We have a strong expertise in working vessels in the spot market with a variety of cargoes in multiple trading routes in order to further stabilise and optimise earnings.</p>
          <p>Our advantage stands in combining trends with the global demand and geographical factors under zealous and thorough trading route diversification. Performing business with major trading houses over the years on repeated basis has allowed us to develop long-standing relations.</p>
          <img
          src="/assets/tanker ship 1.jpg"
          alt="tanker ship 1.jpg"
          />
        </div>
        
        <div className="service-card">
          <h3>Ship Husbandry</h3>
          <p>We provide a comprehensive service through the various stages from the declaration of the vessels at the NPA harbours to berthing the vessels, and finally securing the vessels departure certificate and ensuring that the vessels leave the port efficiently and quickly without incurring unnecessary demurrage.</p>
          <p>Luztow Provides logistics support and midwives the loading of petroleum products at refineries. We also assist  programming of vessels, the mitigation of STS operations and the provision of fenders, hoses and mooring of vessels, amongst other services.</p>
          <p>This entails the process from declaring the arrival of the vessels from ports, sending the vessels to discharge, to securing tug boats and eventually dry tank certificates. It also includes the payment of NPA and NIMASA dues as well as custom clearance.</p>
          <img
            src="/assets/tankervessel.jpg"
            alt="tankervessel.jpg"
          />
        </div>
        <div className="service-card">
          <h3>Ship Protective Agency</h3>
          <p>Our deep understanding of local regulations and industry best practices helps us to navigate complex waters with ease.</p>
          <p>Luztow Supervises the welfare of the crew and supplies chandling services for the vessel. Other Services include but are not limited to immigration clearance, crew transfer, delivery of ship spare parts, supply of fresh water, hotel reservations, hospital transfers etc.</p>
        </div>

        <div className="service-card">
          <h3>Special Project</h3>
          <p>From planning and coordination to execution and tracking, we handle every aspect of your logistics and special project needs with utmost precision. You can rely on our extensive network, industry expertise, and cutting-edge technology to optimize your supply chain.</p>
          <img
            src="/assets/idea.jpg"
            alt="idea.jpg"
          />
        </div>
        <div className="service-card">
          <h3>Ship Management </h3>
          <p>Luztow Logistics provides a top level Global ship management  specialized in the transportation of refined petroleum products.</p>
          <p>We lease Support Vessels, Oil Tankers to major and independent Oil Marketers for lightening of imported products and for refinery loading, either on voyage and time charter contracts.</p>
          <p>We also provide offshore support; Lunch boat hire services, Towage and Barge Operations, Ship-Ship Transfer Operations etc. Our local knowledge of operational conditions and strong relationship with all Local Authorities and Departments, ensures your best interests are maintained.</p>
          <p>We are proud of our expertise in handling all types vessels from Gas- Chemical -Oil tankers in all Nigerian Sea Ports.</p>
          <img
            src="/assets/oil rig 1.jpg"
            alt="Shipping service"
          />
        </div>
        <div className="service-card">
          <h3>Oil and Gas Industry Support</h3>
          <p>Luztow Logistics Int'l Ltd is an independent oil trading company registered in Nigeria with the Corporate Affairs Commission CAC. We are actively involved in the importation, distribution, storage and trading of Petroleum products and other hydrocarbons.</p>
          <p>We began operations in the downstream sector of the Nigerian energy market, and we have grown over the last few years. We have developed and established foundation for growth, and we have gained prominence in performance in the competitive and highly capital intensive energy sector. At Dowell Maritime & Oil Resources Limited, we trade on refined petroleum products: AGO, PMS, LPFO, ATK, DPK, LPG and lubricating oil and Gas on independent and joint venture basis.</p>
        </div>
        <div className="service-card">
          <h3>Cargo Haulage</h3>
          <p>Our team understands the complexities of cargo haulage and why you need reliable and timely cargo transportationservices. We ensure seamlessdelivery of your goods from anywhere to your destination.</p>
          <img
            src="/assets/Haulage 1.jpg"
            alt="Shipping service"
          />
        </div>
        <div className="service-card">
          <h3>Information and Communication Technology</h3>
          <p>Luztow Resources Ltd offers comprehensive Information and Communication Technology services, which includes but not limited to, web development, mobile application development software development, IT consulting, network solutions, and digital transformation. We leverage cutting-edge technology to enhance your business operations, improve efficiency, and drive innovation in the digital age.</p>
          <img
            src="/assets/think.jpg"
            alt="Information and Communication Technology"
          />
        </div>
      </div>
    </div>
  );
}
